'use strict';

(function(doc, win, objName) {
    let hoax = {};

    const addEvent = 'addEventListener';
    const getByTag = 'getElementsByTagName';
    const qsa      = 'querySelectorAll';
    const cn       = 'className';
    const html     = doc.documentElement;

    const easterDateCache = {};
    const holidaysCache   = {};

    /**
     * Initialisation functions
     *
     * @return {Void}
     */
    function init() {}

    /**
     * Wrapper for querySelectorAll
     *
     * If the result has length, and it's 1, return the 1 element.
     *
     * The returned object has `toArray()` method attached to it, so you always
     * can do forEach etc.
     *
     * The returned obejct also has an `org` property, with the original
     * querySelectorAll result in it.
     *
     * @return {Mixed}
     */
    function _query(selector, context) {
        let result   = (context || doc)[qsa](selector);
        const backup = result;

        if (result.length === 0) {
            return null;
        }

        result = result.length && result.length === 1 ? result[0] : result;

        result.org = backup;

        result.toArray = function() {
            return hoax.toArray(result);
        };

        return result;
    }

    hoax = _query;

    /**
     * Converts node_list to array with `slice()`
     *
     * @return {Array}
     */
    hoax.toArray = function(node_list) {
        return (node_list && node_list.length
                ? Array.prototype.slice.call(node_list)
                : [node_list]);
    };

    /**
     * Find closest parent selector to element
     *
     * Goes outwards, includes element itself
     *
     * @param  element element
     * @param  string  selector
     * @return element
     * @link   Taken from <https://gist.github.com/Daniel-Hug/abbded91dd55466e590b>
     */
    hoax.closest = (() => {
        const prototype = HTMLElement.prototype;
        const matches   = (
            prototype.matches ||
            prototype.webkitMatchesSelector ||
            prototype.mozMatchesSelector ||
            prototype.msMatchesSelector ||
            prototype.oMatchesSelector
        );

        return function closest(element, selector) {
            if (element === null) {
                return;
            }
            if (matches.call(element, selector)) {
                return element;
            }
            return closest(element.parentElement, selector);
        };
    })();

    /**
     * Vanilla version of jQuery.live
     *
     * @param  string   selector
     * @param  string   eventType
     * @param  function handler
     * @param  element  elementScope
     * @return void
     * @link   Taken from <https://gist.github.com/Daniel-Hug/abbded91dd55466e590b>
     */
    hoax.live = function(selector, eventType, handler, elementScope) {
        (elementScope || doc)[addEvent](eventType, function(event) {
            const listeningTarget = hoax.closest(event.target, selector);
            if (listeningTarget) {
                handler.call(listeningTarget, event);
            }
        });
    };

    /**
     * Fetch a script with a callback on success
     *
     * @link   http://stackoverflow.com/a/28002292/954798
     * @param  {Object} options {url: '', success: funciton() {}}
     * @return {Void}
     */
    hoax.getScript = function(options) {
        let script  = doc.createElement('script');
        const prior = doc[getByTag]('script')[0];

        script.async = 1;
        prior.parentNode.insertBefore(script, prior);

        script.onload = script.onreadystatechange = function(_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script        = undefined;

                if (!isAbort) {
                    options.success();
                }
            }
        };

        script.src = options.url;
    };

    /**
     * Converts key-value pairs to a URL param string
     *
     * @return {String} Example: `{a:foo, b:bar}` becomes `a=foo&b=bar`
     */
    hoax.parseParams = function(object) {
        let encodedString = '';
        for (let prop in object) {
            if (prop in object) {
                if (encodedString.length > 0) {
                    encodedString += '&';
                }
                encodedString += encodeURIComponent(prop);
                encodedString += '=';
                encodedString += encodeURIComponent(object[prop]);
            }
        }
        return encodedString;
    };

    /**
     * Add class to element
     *
     * @link   http://youmightnotneedjquery.com/#add_class
     * @param  {Element} el        Element to get a new class
     * @param  {String}  className New class
     * @return {Void}
     */
    hoax.addClass = function(el, className) {
        if (el !== null) {
            if (el.classList) {
                el.classList.add(className);
            } else if (el[cn].indexOf(className) === -1) {
                el[cn] += ' ' + className;
            }
        }
    };

    /**
     * Remove class from element
     *
     * @link   http://youmightnotneedjquery.com/#remove_class
     * @param  {Element} el        Element to loose a class
     * @param  {String}  className Class to be removed - can contain a
     *                             star-wildcard: `*`
     * @return {Void}
     */
    hoax.removeClass = function(el, className) {
        const wildcard = (className.indexOf('*') !== -1);
        if (el.classList && !wildcard) {
            el.classList.remove(className);
        } else {
            if (wildcard) {
                className = className.replace('*', '[a-zA-Z0-9_-]*');
            }
            el[cn] = el[cn].replace(
                new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'gi'),
                '',
            );
        }
    };

    /**
     * Does the element have specified class
     *
     * @link   http://youmightnotneedjquery.com/#has_class
     * @param  {Element} el        Element to be searched for class
     * @param  {String}  className Class to be searched for
     * @return {Boolean}
     */
    hoax.hasClass = function(el, className) {
        const wildcard = (className.indexOf('*') !== -1);
        if (el.classList && !wildcard) {
            return el.classList.contains(className);
        } else {
            if (wildcard) {
                className = className.replace('*', '[a-zA-Z0-9_-]*');
            }
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el[cn]);
        }
    };

    /**
     * Toggles class on element
     * @return {Void}
     */
    hoax.toggleClass = function(el, className) {
        if (hoax.hasClass(el, className)) {
            hoax.removeClass(el, className);
        } else {
            hoax.addClass(el, className);
        }
    };

    /**
     * Document ready drop-in
     *
     * Slightly modified by Brego to minify better, and fit the coding style.
     *
     * @link   https://github.com/jfriend00/docReady
     * @author @jfriend00
     * @param  {Function} callback Function to be called on document ready event
     * @param  {Mixed}    context  Will be passed to the function as the first
     *                             argument
     * @return {Void}
     */
    hoax.documentReady = function(callback, context) {
        let readyList                   = [];
        let readyFired                  = false;
        let readyEventHandlersInstalled = false;

        function ready() {
            if (!readyFired) {
                readyFired = true;
                for (let i = 0; i < readyList.length; i++) {
                    readyList[i].fn.call(win, readyList[i].ctx);
                }
                readyList = [];
            }
        }

        function readyStateChange() {
            if (doc.readyState === 'complete') {
                ready();
            }
        }

        if (readyFired) {
            setTimeout(function() { callback(context); }, 1);
            return;
        } else {
            readyList.push({
                fn:  callback,
                ctx: context,
            });
        }
        if (doc.readyState === 'complete' || (!doc.attachEvent && doc.readyState === 'interactive')) {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            if (doc[addEvent]) {
                doc[addEvent]('DOMContentLoaded', ready, false);
                win[addEvent]('load', ready, false);
            } else {
                doc.attachEvent('onreadystatechange', readyStateChange);
                win.attachEvent('onload', ready);
            }
            readyEventHandlersInstalled = true;
        }
    };

    /**
     * Gets the input element's selection (also, in effect, caret position)
     *
     * @link   Taken from <http://stackoverflow.com/a/4207763/954798>
     * @return {Object} {start: x, end: y}
     */
    hoax.getInputSelection = function(el) {
        let start = 0;
        let end   = 0;
        let normalizedValue;
        let range;
        let textInputRange;
        let len;
        let endRange;

        if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
            start = el.selectionStart;
            end   = el.selectionEnd;
        } else {
            range = doc.selection.createRange();

            if (range && range.parentElement() === el) {
                len             = el.value.length;
                normalizedValue = el.value.replace(/\r\n/g, '\n');

                // Create a working TextRange that lives only in the input
                textInputRange = el.createTextRange();
                textInputRange.moveToBookmark(range.getBookmark());

                // Check if the start and end of the selection are at the very
                // end of the input, since moveStart/moveEnd doesn't return what
                // we want in those cases
                endRange = el.createTextRange();
                endRange.collapse(false);

                if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    start = end = len;
                } else {
                    start = -textInputRange.moveStart('character', -len);
                    start += normalizedValue.slice(0, start).split('\n').length - 1;

                    if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
                        end = len;
                    } else {
                        end = -textInputRange.moveEnd('character', -len);
                        end += normalizedValue.slice(0, end).split('\n').length - 1;
                    }
                }
            }
        }

        return {
            start: start,
            end:   end,
        };
    };

    /**
     * Get element height (in px)
     *
     * @return {Integer}
     */
    hoax.getHeight = function(el) {
        if (el === win) {
            return Math.max(html.clientHeight, win.innerHeight || 0);
        }
        return Math.max(el.scrollHeight, el.offsetHeight, el.clientHeight);
    };

    /**
     * Get element height (in px)
     *
     * @return {Integer}
     */
    hoax.getWidth = function(el) {
        if (el === win) {
            return Math.max(html.clientWidth, win.innerWidth || 0);
        }
        return Math.max(el.scrollWidth, el.offsetWidth, el.clientWidth);
    };

    /**
     * Get element position in document (offset) in px
     *
     * @link   Found at: <http://www.quirksmode.org/js/findpos.html>
     * @return {Object} {top: x, left: y}
     */
    hoax.getPos = function(el) {
        let x = 0;
        let y = 0;
        if (el.offsetParent) {
            do {
                x += el.offsetLeft;
                y += el.offsetTop;
            } while ((el = el.offsetParent));
        }
        return {
            top:  y,
            left: x,
        };
    };

    /**
     * Get viewport position in the document
     *
     * @return {Object} {top: x, left: y}
     */
    hoax.getWinPos = function() {
        const supportPageOffset = win.pageXOffset !== undefined;
        const isCSS1Compat      = ((doc.compatMode || '') === 'CSS1Compat');

        const x = supportPageOffset ? win.pageXOffset : isCSS1Compat ? html.scrollLeft : doc.body.scrollLeft;
        const y = supportPageOffset ? win.pageYOffset : isCSS1Compat ? html.scrollTop : doc.body.scrollTop;

        return {
            top:  y,
            left: x,
        };
    };

    // /**
    //  * Get fontsize of an element (defaults to <html>)
    //  * Taken from:
    //  * http://tzi.fr/js/convert-em-in-px
    //  */
    // hoax.getElementFontSize = function(context) {
    //     // Returns a number
    //     return parseFloat(
    //         // of the computed font-size, so in px
    //         getComputedStyle(
    //             // for the given context
    //             context
    //             // or the root <html> element
    //             || html // jshint ignore:line
    //         ).fontSize
    //     );
    // };

    // /**
    //  * Get pixel value of the provided em value in context (defaults to <html>)
    //  * Taken from:
    //  * http://tzi.fr/js/convert-em-in-px
    //  */
    // hoax.convertEm = function(value, context) {
    //     return value * hoax.getElementFontSize(context);
    // };

    // /**
    //  * Get pixel value of the provided rem value in context of <html>
    //  * Taken from:
    //  * http://tzi.fr/js/convert-em-in-px
    //  */
    // hoax.convertRem = function(value) {
    //     return hoax.convertEm(value);
    // };

    hoax.replaceAll = function(str, mapObj) {
        const pattern = new RegExp(Object.keys(mapObj).join('|'), 'gi');
        return str.replace(pattern, function(matched) {
            return mapObj[matched.toLowerCase()];
        });
    };

    /**
     * @link   Taken from <http://www.quirksmode.org/js/cookies.html>
     * @return {Void}
     */
    hoax.cookieSet = function(name, value, days) {
        let expires = '';
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        doc.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
    };

    /**
     * @link   Taken from <http://www.quirksmode.org/js/cookies.html>
     * @return {String} Value of the cookie
     */
    hoax.cookieGet = function(name, defaultValue = null) {
        const nameEQ = name + '=';
        const ca     = doc.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return defaultValue;
    };

    /**
     * @link   Taken from <http://www.quirksmode.org/js/cookies.html>
     * @return {Void}
     */
    hoax.cookieDelete = function(name) {
        this.cookieSet(name, '', -1);
    };

    hoax.dynamicSort = function(property, useNatSort) {
        let sortOrder = 1;
        let isArray   = false;
        if (property[0] === '-') {
            sortOrder = -1;
            property  = property.substr(1);
        }
        if (property.indexOf('.') !== -1) {
            isArray = true;
        }
        return function(a, b) {
            let result = null;
            if (isArray) {
                const newA = hoax.getPropByString(a, property);
                const newB = hoax.getPropByString(b, property);

                if (useNatSort) {
                    result = hoax.natSort(newA, newB);
                } else {
                    result = (newA < newB) ? -1 : (newA > newB) ? 1 : 0;
                }
                return result * sortOrder;
            }

            if (useNatSort) {
                result = hoax.natSort(a[property], b[property]);
            } else {
                result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            }
            return result * sortOrder;
        };
    };

    hoax.dynamicNatSort = function(property) {
        return hoax.dynamicSort(property, true);
    };

    hoax.dynamicSortMultiple = function() {
        /*
         * save the arguments object as it will be overwritten
         * note that arguments object is an array-like object
         * consisting of the names of the properties to sort by
         */
        const props    = Array.prototype.slice.call(arguments);
        let useNatSort = false;

        if (props[0] === true) {
            useNatSort = true;
            props.shift();
        }
        return function(obj1, obj2) {
            let i      = 0;
            let result = 0;

            const numberOfProperties = props.length;
            /* try getting a different result from 0 (equal)
             * as long as we have extra properties to compare
             */
            while (result === 0 && i < numberOfProperties) {
                if (useNatSort) {
                    result = hoax.dynamicNatSort(props[i])(obj1, obj2);
                } else {
                    result = hoax.dynamicSort(props[i])(obj1, obj2);
                }
                i++;
            }
            return result;
        };
    };

    hoax.dynamicNatSortMultiple = function() {
        const props = Array.prototype.slice.call(arguments);
        props.unshift(true);
        return hoax.dynamicSortMultiple.apply(this, props);
    };

    hoax.getPropByString = function(obj, propString) {
        if (!propString) {
            return obj;
        }

        const props = propString.split('.');

        let prop;
        let i;
        let iLen = props.length - 1;

        for (i = 0; i < iLen; i++) {
            prop = props[i];

            let candidate = obj[prop];
            if (candidate !== undefined) {
                obj = candidate;
            } else {
                break;
            }
        }
        return obj[props[i]];
    };

    // Taken from: http://www.davekoelle.com/files/alphanum.js
    hoax.natSort = function(a, b) {
        if (!a || !b) {
            return 0;
        }

        function chunkify(t) {
            let tz = [];
            let x  = 0;
            let y  = -1;
            let n  = 0;
            let i;
            let j;

            if (typeof t === 'number') {
                t = t.toString();
            }

            while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
                let m = (i === 46 || (i >= 48 && i <= 57));
                if (m !== n) {
                    tz[++y] = '';

                    n = m;
                }
                tz[y] += j;
            }
            return tz;
        }

        let aa = chunkify(a);
        let bb = chunkify(b);

        for (let x = 0; aa[x] && bb[x]; x++) {
            if (aa[x] !== bb[x]) {
                let c = Number(aa[x]);
                let d = Number(bb[x]);
                if (c === aa[x] && d === bb[x]) {
                    return c - d;
                } else {
                    return (aa[x] > bb[x]) ? 1 : -1;
                }
            }
        }
        return aa.length - bb.length;
    };

    hoax.diceCoefficient = function(value, alternative) {
        let pairs;
        let alternativePairs;
        let intersections;
        let iterator;
        let length;
        let alternativeLength;
        let alternativeIterator;
        let alternativePair;
        let pair;

        const getBigrams = value_bigram => {
            let nGrams = [];
            let index  = null;
            let n      = 2;

            if (value_bigram === null || value_bigram === undefined) {
                return nGrams;
            }

            value_bigram = String(value_bigram);
            index        = value_bigram.length - n + 1;

            if (index < 1) {
                return nGrams;
            }

            while (index--) {
                nGrams[index] = value_bigram.substr(index, n);
            }

            return nGrams;
        };

        pairs             = getBigrams(String(value).toLowerCase());
        alternativePairs  = getBigrams(String(alternative).toLowerCase());
        intersections     = 0;
        iterator          = -1;
        alternativeLength = alternativePairs.length;
        length            = pairs.length;

        while (++iterator < length) {
            pair                = pairs[iterator];
            alternativeIterator = -1;

            while (++alternativeIterator < alternativeLength) {
                alternativePair = alternativePairs[alternativeIterator];
                if (pair === alternativePair) {
                    intersections++;
                    alternativePairs[alternativeIterator] = '';
                    break;
                }
            }
        }

        return 2 * intersections / (pairs.length + alternativeLength);
    };

    /**
     * Returns date of easter for year y (catches the response)
     *
     * @link Taken from <http://furgelnod.com/2014/easter-date-function-for-javascript/>
     */
    hoax.easterDate = function(y) {
        if (easterDateCache[y]) {
            return easterDateCache[y];
        }

        const org_y = y;

        y     = Math.floor(y);
        let c = Math.floor(y / 100);
        let n = y - 19 * Math.floor(y / 19);
        let k = Math.floor((c - 17) / 25);
        let i = c - Math.floor(c / 4) - Math.floor((c - k) / 3) + 19 * n + 15;
        i     = i - 30 * Math.floor(i / 30);
        i     = i - Math.floor(i / 28) * (1 - Math.floor(i / 28) * Math.floor(29 / (i + 1)) * Math.floor((21 - n) / 11));
        let j = y + Math.floor(y / 4) + i + 2 - c + Math.floor(c / 4);
        j     = j - 7 * Math.floor(j / 7);
        let l = i - j;
        let m = 3 + Math.floor((l + 40) / 44);
        let d = l + 28 - 31 * Math.floor(m / 4);
        let z = new Date();
        z.setFullYear(y, m - 1, d);

        easterDateCache[org_y] = z;

        return z;
    };

    /**
     * Returns danish holiday dates for year y (as an array of strings)
     *
     * Note: IGNORE THE TIMES AND TIMEZONES
     *
     * @link Original PHP function taken from <http://www.eksperten.dk/spm/936923>
     * @return {Array} Array of string dates "YYYY-MM-DD"
     */
    hoax.getHolidays = function(y) {
        if (holidaysCache[y]) {
            return holidaysCache[y];
        }

        const easter_date      = hoax.easterDate(y); // This is a Date...
        const easter_date_time = easter_date.getTime();
        const ONEDAY           = (60 * 60 * 24);

        let holidays     = [];
        let holidays_out = [];

        // holidays.push(new Date(easter_date_time-(49*ONEDAY) * 1000));     // Fastelavn
        // holidays.push(new Date(hoax.mktime(0,0,0,2,14,  y)  * 1000));     // Valentinsdag
        holidays.push(new Date(easter_date_time - (7 * ONEDAY) * 1000));  // Palmesøndag
        holidays.push(new Date(easter_date_time - (3 * ONEDAY) * 1000));  // Skærtorsdag
        holidays.push(new Date(easter_date_time - (2 * ONEDAY) * 1000));  // Langfredag
        holidays.push(new Date(easter_date_time));                        // Påskedag
        holidays.push(new Date(easter_date_time + (1 * ONEDAY) * 1000));  // 2. påskedag
        holidays.push(new Date(easter_date_time + (26 * ONEDAY) * 1000)); // Store bededag
        holidays.push(new Date(easter_date_time + (39 * ONEDAY) * 1000)); // Kristi himmelfartsdag
        holidays.push(new Date(easter_date_time + (49 * ONEDAY) * 1000)); // Pinsedag
        holidays.push(new Date(easter_date_time + (50 * ONEDAY) * 1000)); // 2. pinsedag
        holidays.push(new Date(y, 1 - 1, 1, 0, 0, 0, 0));                 // nytårsdag
        holidays.push(new Date(y, 5 - 1, 1, 0, 0, 0, 0));                 // 1. maj
        holidays.push(new Date(y, 6 - 1, 5, 0, 0, 0, 0));                 // Grundlovs dag
        holidays.push(new Date(y, 12 - 1, 24, 0, 0, 0, 0));               // juleaften
        holidays.push(new Date(y, 12 - 1, 25, 0, 0, 0, 0));               // juledag
        holidays.push(new Date(y, 12 - 1, 26, 0, 0, 0, 0));               // 2. juledag
        holidays.push(new Date(y, 12 - 1, 31, 0, 0, 0, 0));               // nytårs aften

        holidays.forEach(date => holidays_out.push(
            date.getFullYear() + '-' +
            ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
            ('0' + date.getDate()).slice(-2),
        ));

        holidays_out.sort();

        holidaysCache[y] = holidays_out;
        return holidays_out;
    };

    /**
     * Dirty check for IE version, using conditional comments
     *
     * @return {Mixed} Contains `undefined` if this is not IE, otherwise the
     *                 integer version number
     */
    hoax.ie = (function() {
        let v   = 3;
        let div = doc.createElement('div');
        let all = div.getElementsByTagName('i');

        // eslint-disable-next-line curly
        while ((div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->', all[0])) {
            //
        }

        return v > 4 ? v : undefined;
    }());

    /**
     * @return {String} Current protocol 'https://' or 'http://'
     */
    hoax.http = (function() {
        return ('https:' === doc.location.protocol ? 'https://' : 'http://');
    }());

    hoax.activity_counter = 0;

    hoax.activityAdd = () => {
        hoax.activity_counter++;
    };

    hoax.activitySub = () => {
        hoax.activity_counter--;
    };

    /**
     * Run Initialisation
     */
    init();

    /**
     * Assign this helper object to a global variable
     */
    win[objName] = hoax;

}(document, window, 'hoax'));

/* eslint-disable */
/**!
 *
 * atomic.js by Todd Motto
 *
 * Modified by <kbd@hiper.dk> to use XDomainRequest when necessary
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @version <https://git.io/v2EHV>
 * @link    <http://github.com/toddmotto/atomic>
 */
(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], (function() {
            return factory(root);
        }));
    } else if (typeof exports === 'object') {
        module.exports = factory(root);
    } else {
        window.hoax.xhr = factory(root);
    }
// })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this,
// (function (root) {
})(window, (function(root) {

// }
// (function(root, factory) {
//     if (typeof define === 'function' && define.amd) {
//         define(factory);
//     } else if (typeof exports === 'object') {
//         module.exports = factory;
//     } else {
//         root.hoax.xhr = factory(root);
//     }
// })(this, function(root) {

    var exports  = {};
    var requests = [];
    var config   = {
        contentType: 'application/x-www-form-urlencoded',
        timeout:     5000,
    };
    var parse    = function(req) {
        var result;
        try {
            result = JSON.parse(req.responseText);
        } catch (e) {
            result = req.responseText;
        }
        return [result, req];
    };

    window.addEventListener('beforeunload', function() {
        for (var i = 0; i < requests.length; i++) {
            requests[i].abort();
        }
    });

    var xhr = function(type, url, data) {
        var XHR     = root.XMLHttpRequest || ActiveXObject;
        var request = new XHR('MSXML2.XMLHTTP.3.0');
        var methods = {
            success: function() {},
            error:   function() {},
            always:  function() {},
        };

        if (url.indexOf('http') !== -1 && (new XMLHttpRequest().withCredentials === undefined)) {
            request = new XDomainRequest();
            request.timeout = config.timeout;
            window.hoax.activityAdd();

            request.open(type, url);

            request.onload  = function() {
                window.hoax.activitySub();
                methods.success.apply(methods, parse(request));
            };
            request.onerror = function() {
                window.hoax.activitySub();
                methods.error.apply(methods, parse(request));
            };
            // XDomainRequest.onprogress for "always"?

            setTimeout(function() {
                request.send(data);
            }, 0);

        } else {
            window.hoax.activityAdd();

            request.open(type, url, true);
            request.setRequestHeader('Content-type', config.contentType);
            request.timeout = config.timeout;

            if (url.indexOf('hiper.dk') !== -1 || url.indexOf('localhost') !== -1) {
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            }

            request.onreadystatechange = function() {
                var req = parse(request);
                if (request.readyState === 4) {
                    if (request.status >= 200 && request.status < 300) {
                        window.hoax.activitySub();
                        methods.success.apply(methods, req);
                    } else {
                        window.hoax.activitySub();
                        methods.error.apply(methods, req);
                    }
                    methods.always.apply(methods, req);
                }
            };

            request.send(data);
        }

        requests.push(request);

        var callbacks = {
            success: function(callback) {
                methods.success = callback;
                return callbacks;
            },
            error:   function(callback) {
                methods.error = callback;
                return callbacks;
            },
            always:  function(callback) {
                methods.always = callback;
                return atomXHR;
            },
            abort:   function() {
                // only if request is still not loaded, we should abort it
                if (request && request.readyState !== 4) {
                    request.onreadystatechange = null;
                    request.abort();
                }
            },
        };

        return callbacks;
    };

    exports.get = function(src) {
        return xhr('GET', src);
    };

    exports.put = function(url, data) {
        return xhr('PUT', url, data);
    };

    exports.post = function(url, data) {
        return xhr('POST', url, data);
    };

    exports.delete = function(url) {
        return xhr('DELETE', url);
    };

    exports.setContentType = function(value) {
        config.contentType = value;
    };

    exports.setTimeout = function(timeout) {
        config.timeout = timeout;
    };

    return exports;
// });
}));

